import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("Spirit Garden crashed:", error);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            background: "linear-gradient(160deg,#FFFDF5,#FFF3C4)",
            color: "#3A2600",
            fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
          }}
        >
          <div
            style={{
              maxWidth: 520,
              width: "100%",
              border: "1px solid rgba(196,143,32,.28)",
              borderRadius: 20,
              background: "rgba(255,253,242,.94)",
              padding: 22,
              boxShadow: "0 10px 30px rgba(138,90,8,.12)",
            }}
          >
            <h1 style={{ margin: "0 0 8px", fontSize: 24 }}>
              Spirit Garden needs a refresh
            </h1>
            <p style={{ margin: "0 0 14px", lineHeight: 1.6 }}>
              The app hit an error while opening. Try refreshing once. If this
              stays here, copy the message below and send it to me.
            </p>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                background: "rgba(255,243,196,.55)",
                borderRadius: 12,
                padding: 12,
                fontSize: 12,
                overflowX: "auto",
              }}
            >
              {this.state.error.message}
            </pre>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
